// Thin fetch wrapper around the Go API. In dev Vite proxies /api/* to
// :8080; in production Coolify Traefik StripPrefix routes /api/* to the
// API container.

const BASE = import.meta.env.VITE_API_BASE ?? '/api';

export async function getJSON(path, opts = {}) {
  const headers = { Accept: 'application/json', ...(opts.headers || {}) };
  if (opts.apiKey) headers['X-Api-Key'] = opts.apiKey;
  const res = await fetch(BASE + path, { ...opts, headers });
  if (!res.ok) {
    let body = null;
    try { body = await res.json(); } catch (_) { /* ignore */ }
    const err = new Error(`HTTP ${res.status} on ${path}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return res.json();
}

export async function postJSON(path, body, opts = {}) {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...(opts.headers || {}),
  };
  if (opts.apiKey) headers['X-Api-Key'] = opts.apiKey;
  const res = await fetch(BASE + path, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status} on ${path}`);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
}

// Pricing.
export const fetchPlans = () => getJSON('/v1/plans');

// Sample notices (no auth). GET /v1/sample/notices returns {data: [Notice, ...]}.
// Pass {limit} (capped at 50 server-side) and/or {portal} to scope the feed.
export async function fetchSampleTenders(opts = {}) {
  const limit = Math.min(Math.max(opts.limit || 25, 1), 50);
  const params = new URLSearchParams({ limit: String(limit) });
  if (opts.portal) params.set('portal_slug', opts.portal);
  const resp = await getJSON(`/v1/sample/notices?${params.toString()}`);
  return resp?.data || [];
}

// Signup.
export const startSignup = (body) => postJSON('/signup', body);
export const verifySignup = (token) =>
  getJSON('/signup/verify?token=' + encodeURIComponent(token), {
    headers: { Accept: 'application/json' },
  });
